import { useState, useEffect, useCallback } from 'react';
import { tokenManager } from '../config/authConfig';
import API_CIFRA from '../config/Variables_apis';

/**
 * Trae los pines a pintar en el mapa base del ciudadano.
 * Usa el endpoint público-seguro `api/incidencia/mapa/` (IncidenciaMapaSerializer
 * en el backend) — nunca el listado completo de incidencias, que sí trae datos
 * personales del denunciante y no debe llegar a esta pantalla sin login real.
 * `categoriaId` (opcional) filtra en el servidor (`?categoria=`, ya soportado
 * por la vista) en vez de traer todo y filtrar en el cliente.
 */
const useIncidenciasMapa = (categoriaId = null) => {
  const [pines, setPines] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const cargarPines = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const token = tokenManager.getAccessToken();
      const headers = { 'Content-Type': 'application/json' };
      if (token && !tokenManager.isTokenExpired()) {
        headers.Authorization = `Bearer ${token}`;
      }

      const url = categoriaId
        ? `${API_CIFRA.incidencia.mapa}?categoria=${categoriaId}`
        : API_CIFRA.incidencia.mapa;

      const response = await fetch(url, { method: 'GET', headers });
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || 'Error al cargar los incidentes del mapa');
      }

      setPines(Array.isArray(data) ? data : []);
    } catch (err) {
      setError(err.message || 'Error al cargar los incidentes del mapa');
    } finally {
      setLoading(false);
    }
  }, [categoriaId]);

  useEffect(() => {
    cargarPines();
  }, [cargarPines]);

  return { pines, loading, error, recargar: cargarPines };
};

export default useIncidenciasMapa;
